import { api } from "../../api/api";
import { IWhatsappServiceProvider } from "../../contexts/AuthProvider";

export interface ISendGenericWhatsAppPayload {
  name_of_guest: string;
  menu_message: string;
  menu_url: string;
}

export interface ISendGenericWhatsAppTemplateRequest {
  company_outlet_uuid: string;
  env_key: string;
  toNumber: string;
  platform?: IWhatsappServiceProvider
  payload: any;
}

/**
 * Sends a generic WhatsApp template message.
 * POST /api/v1/general/send-generic-whatsapp-template
 */
export const sendGenericWhatsAppTemplateAsync = async (
  request: ISendGenericWhatsAppTemplateRequest,
): Promise<void> => {
  await api.post("/general/send-generic-whatsapp-template", request);
};
